import { useRef, useEffect, useCallback } from 'react';
import SignaturePadLib from 'signature_pad';

export default function SignaturePad({ onEnd, width = 500, height = 200 }) {
  const canvasRef = useRef(null);
  const padRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    const canvas = canvasRef.current;
    canvas.width = width;
    canvas.height = height;

    padRef.current = new SignaturePadLib(canvas, {
      backgroundColor: 'rgb(255, 255, 255)',
      penColor: 'rgb(30, 30, 30)',
      minWidth: 1,
      maxWidth: 2.5
    });

    padRef.current.addEventListener('endStroke', () => {
      if (onEnd) onEnd(padRef.current.toDataURL());
    });

    return () => {
      if (padRef.current) padRef.current.off();
    };
  }, [width, height]);

  const clear = useCallback(() => {
    if (padRef.current) {
      padRef.current.clear();
      if (onEnd) onEnd(null);
    }
  }, [onEnd]);

  return (
    <div>
      <canvas
        ref={canvasRef}
        style={{
          border: '1px solid #e0e0e0',
          borderRadius: '10px',
          cursor: 'crosshair',
          touchAction: 'none',
          width: '100%',
          maxWidth: `${width}px`,
          height: `${height}px`,
          background: 'white'
        }}
      />
      <div style={{ marginTop: '6px' }}>
        <button
          type="button"
          onClick={clear}
          style={{
            padding: '5px 14px',
            fontSize: '12px',
            fontWeight: 500,
            border: '1px solid #ddd',
            borderRadius: '6px',
            background: 'white',
            cursor: 'pointer',
            color: '#888',
            transition: 'border-color 0.15s, color 0.15s'
          }}
          onMouseEnter={(e) => {
            e.target.style.borderColor = '#aaa';
            e.target.style.color = '#555';
          }}
          onMouseLeave={(e) => {
            e.target.style.borderColor = '#ddd';
            e.target.style.color = '#888';
          }}
        >
          Clear
        </button>
      </div>
    </div>
  );
}
